
/**
	callback for the find function in the array prototype 
	ex: arr.find(find({a:11,b:22}))
*/

function find(elements){
	return function(item){
		var test = true; 
		for (let [key,value] of Object.entries(elements)){
			test = test && ((item[key] === value) || false  ) ; 
		}
		if (test) return item;
	}
}

/**
Creates a real Array from the list (anything that can be iterated over). 
Useful for transmuting the arguments object.
*/
function toArray(list){
	return Array.prototype.slice.call(list)
}


/**
Returns the values in list without the elements that the truth test (predicate) passes. 
The opposite of filter. predicate is transformed through iteratee to facilitate shorthand syntaxes.
Similar to underscore reject
*/

function reject(array,predicate,context){
	if (typeof predicate !== 'function') throw new Error('Array:reject, parameter should be a function');
	return array.filter( (item) => !predicate(item) );
}

export var array = { find, toArray, reject }

